
export enum StopSequenceModelConflictCd {
	CAPACITY = 'Capacity',
	FIRST_LAST_PIN = 'FirstLastPin',
	OTHER = 'Other',
	SERVICE_TIME = 'ServiceTime'}

